<template>
<div class="page-container" :style="marginTopStyle">
    <div class="columns">
        <div class="column is-1">
            <img width="100px" :src="require('@/assets/img/server.svg')" />
        </div>
        <div class="column is-10">
            <p class="default-settings-title">Connect your Cloud Provider Accounts</p>
            <p class="default-settings-description">
                Your Weap.io account is not connected to a Cloud Provider Account. Use the button <b>Add account</b> from above in order to connect your first Cloud Provider Account. Don't worry, you can connect as many accounts as you need.
                <br></br>
                You can connect accounts from <b>DigitalOcean</b>, <b>Hetzner</b>, <b>AWS (EC2 & Lightsail)</b>, <b>GCP</b>, <b>UpCloud</b>, <b>Scaleway</b>, <b>OVH</b>, <b>Exoscale</b> and <b>Alibaba Cloud</b>. 
                <br><br>
                After adding your account, Weap.io will synchronize with it and you will see your <span class="tooltip is-tooltip-multiline" data-tooltip="To make things easier, we named all the resources Cloudlets. This means that any DigitalOcean Droplets/Volumes, Hetzner Cloud Servers, AWS EC2 instances, etc, will be simply referred to as Cloudlets."><b>Cloudlets</b></span> directly here.
            </p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        marginTop: {
            type: Number,
            default: 0,
        }
    },

    computed: {
        marginTopStyle() {
            return 'margin-top: ' + this.marginTop + 'px !important;';
        },
    },
}
</script>
